const data_task_state = {
  1: {
    en: 'To do',
    fr: 'À faire',
    value: 1,
  },
  2: {
    en: 'Ongoing',
    fr: 'En cours',
    value: 2,
  },
};

export default data_task_state;
